export default {"src":"/_next/static/image/public/images/ic_off_box.8d17149b1cd4c40182955f07319880a7.svg","height":23,"width":103};